<template>
	<div class="view-form">
		<v v-if="isVerticalScreen()" />
		<h v-else />
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import H from './H.vue';
	import V from './V.vue';
	export default {
		name: 'Form',
		components: {
			H,
			V
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>
<style scoped lang="less">
	.view-form {
		width: 100%;
		height: 100%;
	}
	::v-deep {
		.submit-btn {
			width: 152px; 
			height: 42px; 
			border-radius: 21px; 
			background-color: rgb(49, 75, 137); 
			margin-top: 10px;
		}
	}
</style>